import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How long does the UK visa process usually take?",
      answer: "Processing times vary by visa type, but typically range from 2-10 weeks. We provide realistic timelines based on your specific case and current Home Office processing times."
    },
    {
      question: "What is your success rate for UK visa applications?",
      answer: "We maintain a 98% success rate across all visa categories. Our thorough document preparation and expert guidance significantly increase approval chances."
    },
    {
      question: "Do you offer refunds if my visa application is refused?",
      answer: "We offer a partial refund policy depending on the circumstances. Our comprehensive assessment minimizes refusal risks, and we provide detailed guidance on appeal processes if needed."
    },
    {
      question: "Can you help with complex immigration cases?",
      answer: "Yes, we specialize in complex cases including previous refusals, criminal records, and unique circumstances. Our experienced team has successfully handled thousands of complex applications."
    },
  
    {
      question: "What documents do I need to start the process?",
      answer: "Requirements vary by visa type, but typically include passport, financial documents,  and purpose-specific documents. We provide a customized checklist after your  assessment."
    },
    {
      question: "Do you provide support after visa approval?",
      answer: "Yes, we offer post-approval support including travel guidance, accommodation assistance, and settlement support to ensure a smooth transition to the UK."
    },
    {
      question: "How much do your services cost?",
      answer: "Our fees vary based on visa complexity and services required. We offer transparent pricing with no hidden costs and provide detailed quotes after your  assessment."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Frequently Asked Questions</h2>
      
      <div className="max-w-3xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`bg-white border rounded-xl transition-all duration-300 ${
              activeIndex === index 
                ? 'border-blue-300 shadow-lg' 
                : 'border-gray-200 hover:border-blue-200'
            }`}
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full px-6 py-5 text-left flex items-center justify-between group"
            >
              <div className="flex items-center space-x-4">
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${
                  activeIndex === index ? 'bg-blue-600' : 'bg-blue-100 group-hover:bg-blue-200'
                }`}>
                  <span className={`font-bold text-sm transition-colors duration-300 ${
                    activeIndex === index ? 'text-white' : 'text-blue-600'
                  }`}>
                    ?
                  </span>
                </div>
                <span className={`font-semibold text-lg transition-colors duration-300 ${
                  activeIndex === index ? 'text-blue-600' : 'text-gray-900'
                }`}>
                  {faq.question}
                </span>
              </div>
              
              <div className={`transform transition-transform duration-300 ${
                activeIndex === index ? 'rotate-45' : 'rotate-0'
              }`}>
                <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
            </button>

            <div className={`overflow-hidden transition-all duration-300 ${
              activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}>
              <div className="px-6 pb-5">
                <div className="border-t border-gray-100 pt-4">
                  <p className="text-gray-600 leading-relaxed pl-12">{faq.answer}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-8">
        <div className="bg-blue-50 rounded-xl p-6 inline-block">
          <p className="text-gray-700">
            <FontAwesomeIcon icon={faPhone} className='text-rose-600  me-2'/> Need immediate assistance?{' '}
            <span className="text-blue-600 font-semibold">Call us at  0191 250 8966</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;